import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import { StatusTag } from '../../../components/Common/StatusTag'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import PDFViewer from '../../../components/PDFViewer/PDFViewer'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import InternalDocumentComment from '../InternalDocumentComment'
import PopupHandleDocument from './PopupHandleDocumentIncoming'
//Layout
import DashboardLayout from '../../../layouts/DashboardLayout'
// Styled Component
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from '../../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
import { UserListWrapper } from './InternalDocumentIncomingDocDetailPageStyled'
// Ant design
import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  FormOutlined,
  MoreOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  SolutionOutlined,
  HistoryOutlined,
} from '@ant-design/icons'
import { Dropdown, Form, Menu, message, Modal, Tag, Tabs, Row, Col, Button } from 'antd'
// PDF Viewer
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import LinkedTask from '../../../components/Common/Linked/LinkedTask'
import LinkedWork from '../../../components/Common/Linked/LinkedWork'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  DATE_TIME_FORMAT_DEFAULT,
  DOCUMENT_TYPE,
  TYPE_STATUS,
  VIEWLOG_DATE,
} from '../../../constants'
import utils from '../../../utils'
import PopupPhanPhatDocument from '../PopupPhanPhatDocument'
import { InternalDocumentRequest } from '../../../requests/InternalDocumentRequest'

const { confirm } = Modal

const InternalDocumentIncomingIncomingDocDetailPage = props => {
  const [form] = Form.useForm()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    match,
    authenticationStore,
    internalDocumentStore,
    loadingAnimationStore,
    history,
    notificationStore,
    selectPeopleStore,
    aclStore,
  } = props

  const { documentId } = match.params
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const {
    selectedInternalDocumentIncoming,
    internalDocumentCommentList,
    leaderAssignList = [],
    handlerAssignList,
    combinerAssignList,
    followerAssignList,
  } = internalDocumentStore

  const { currentUser } = authenticationStore
  const currentUserName = currentUser?.username

  const [departWithUsers, setDepartWithUsers] = useState([])
  const [loading, setLoading] = useState(true)

  const getAssigneeText = (userList) => {
    if (!userList || userList.length === 0) return ''
    const names = userList
      .map(u => {
        let rawName = u.full_name || u.name || u.name_uppercase || u.assignee_name || ''
        if (!rawName && (u.id || u.username || u.assignee_code)) {
          const uId = u.id || u.username || u.assignee_code
          const userInfo = utils.getInfoUser(
            uId,
            departWithUsers.length > 0
              ? departWithUsers
              : selectPeopleStore.originDepartmentWithUserList
          )
          if (userInfo?.full_name) {
            rawName = userInfo.full_name
          } else {
            rawName = uId
          }
        }
        return utils.getNameInCapitalize(rawName) || rawName
      })
      .filter(Boolean)
    return names.join(', ')
  }

  const isCpctmUser = (u) => {
    if (!u) return false
    const uId = u.id || u.username || u.assignee_code
    const list = (departWithUsers && departWithUsers.length > 0)
      ? departWithUsers
      : selectPeopleStore.originDepartmentWithUserList

    if (uId && list && list.length > 0) {
      const userInfo = utils.getInfoUser(uId, list)
      if (userInfo?.full_name) return true
      for (const dept of list) {
        if (dept.users && dept.users.some(user =>
          user.user_name === uId ||
          user.user_code === uId ||
          user.id === uId ||
          user.username === uId ||
          (u.full_name && user.name_uppercase && user.name_uppercase.toLowerCase() === u.full_name.toLowerCase()) ||
          (u.full_name && user.full_name && user.full_name.toLowerCase() === u.full_name.toLowerCase()) ||
          (u.name && user.name_uppercase && user.name_uppercase.toLowerCase() === u.name.toLowerCase()) ||
          (u.name && user.full_name && user.full_name.toLowerCase() === u.name.toLowerCase())
        )) {
          return true
        }
        if (dept.id === uId || dept.department_id === uId || dept.code === uId) {
          return true
        }
      }
    }
    if (selectPeopleStore.originGroupList?.some(g => String(g.id) === String(uId))) {
      return true
    }
    return false
  }

  const getNonCpctmAssigneeText = (userList) => {
    if (!userList || userList.length === 0) return ''
    const nonCpctmList = userList.filter(u => !isCpctmUser(u))
    return getAssigneeText(nonCpctmList)
  }

  const leaderUsers = leaderAssignList.length > 0 ? leaderAssignList : handlerAssignList
  const handlerUsers = leaderAssignList.length > 0 ? handlerAssignList : combinerAssignList
  const followerUsers =
    leaderAssignList.length > 0
      ? [...combinerAssignList, ...followerAssignList]
      : followerAssignList

  const cpctmLeaderUsers = leaderUsers.filter(isCpctmUser)
  const nonCpctmLeaderText = getNonCpctmAssigneeText(leaderUsers)

  const cpctmHandlerUsers = handlerUsers.filter(isCpctmUser)
  const nonCpctmHandlerText = getNonCpctmAssigneeText(handlerUsers)

  const cpctmFollowerUsers = followerUsers.filter(isCpctmUser)
  const nonCpctmFollowerText = getNonCpctmAssigneeText(followerUsers)

  const {
    authority_issued_id,
    agency_issued,
    date_issued,
    incoming_date,
    incoming_number,
    document_number,
    signer,
    title,
    attachments,
    linkedTask,
    linkedWork,
    end_date,
    start_date,
    document_status,
    created_at,
    user_create,
  } = selectedInternalDocumentIncoming

  const [
    isVisiblePopupHandleDocument,
    setIsVisiblePopupHandleDocument,
  ] = useState(false)
  const [
    isVisiblePopupPhanPhatDocument,
    setIsVisiblePopupPhanPhatDocument,
  ] = useState(false)
  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [attachmentForView, setAttachmentForView] = useState()
  const [commentLeaderList, setCommentLeaderList] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getDepartmentWithUsers()
        const response = await selectPeopleStore.getDepartmentWithUsersV2()
        setDepartWithUsers(response.data)
        setLoading(false)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  useEffect(() => {
    if (handlerAssignList.length === 0) return
    const commentList = toJS(internalDocumentCommentList).filter(
      cmt => !cmt.deleted && cmt.user_name === handlerAssignList[0].id
    )
    setCommentLeaderList(commentList)
  }, [internalDocumentCommentList, handlerAssignList])

  const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
    const authorityList = []
    if (authorityIssuedId) {
      authorityList.push(authorityIssuedId.name)
    }
    if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
      authorityList.push(agencyIssued)
    }
    if (authorityIssuedId || agencyIssued) {
      return authorityList.join(', ')
    }
    return <EmptyText>Không có CQ ban hành.</EmptyText>
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )

  const handleDeleteDocument = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.deleteIncomingInternalDocumentById(documentId)
      history.push('/internal-document/incoming-document')
      message.success('Xóa văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      className: 'custom-confirm-modal',
      okButtonProps: { 
        style: { borderRadius: 8, color: '#ff4d4f', borderColor: '#e8e8e8', backgroundColor: '#fff', boxShadow: 'none' } 
      },
      cancelButtonProps: { style: { borderRadius: 8 } },
      onOk() {
        handleDeleteDocument()
      },
    })
  }

  const menuHandleDocument = (
    <Menu style={{ borderRadius: 12, padding: '8px 0', minWidth: 200 }}>
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_nv_tu_vb__INCOMING
      ) && (
        <Menu.Item
          onClick={() =>
            history.push(
              `/mission/create?document_code=${documentId}&title=${title}&type=INCOMING`
            )
          }
          icon={<ProfileOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo nhiệm vụ từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_cv_tu_vb__INCOMING
      ) && (
        <Menu.Item
          onClick={() => {
            const documentList = attachments.map(el => el.id + '/' + el.name)
            const queryStringParams = queryString.stringify(
              {
                document_list: documentList,
                incoming_number: incoming_number,
                document_title: title,
                document_code: documentId,
                document_type: DOCUMENT_TYPE.INCOMING,
                comments_leader: commentLeaderList.map(cmt => cmt.content),
                leader_name:
                  handlerAssignList.length > 0 &&
                  utils.getNameInCapitalize(handlerAssignList[0].full_name),
              },
              { arrayFormat: 'index' }
            )
            history.push(`/works/create?${queryStringParams}`)
          }}
          icon={<SolutionOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo công việc từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__INCOMING) && (
        <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
          Xóa văn bản
        </Menu.Item>
      )}
    </Menu>
  )

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await internalDocumentStore.getInternalDocumentIncomingById(documentId)
        InternalDocumentRequest.markAsReadDocument(documentId)
      } catch (err) {
        history.push('/internal-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      internalDocumentStore.clearSelectedInternalDocumentIncoming()
      internalDocumentStore.clearAssignList()
      notificationStore.clearNotificationType()
      selectPeopleStore.clearSelected()
    }
  }, [documentId])

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`Văn bản đến số ${incoming_number} | ${systemName} Quản lý VB ${systemName}`}</title>
      </Helmet>
      <style>{`
        .custom-confirm-modal .ant-modal-content {
          border-radius: 16px !important;
        }
      `}</style>
      <PageTitle
        location={props.location}
        title={title}
        showTitle={true}
        status={StatusTag(
          TYPE_STATUS.INTERNAL_DOCUMENT_INCOMING,
          document_status
        )}>
        <HeadingButtonWrapper style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {user_create === currentUserName && aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__INCOMING) && (
            <Button
              onClick={() => history.push(`/internal-document/incoming-document/${documentId}`)}
              icon={<EditOutlined />}
              style={{ borderRadius: 6 }}>
              Chỉnh sửa văn bản
            </Button>
          )}

          {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.xuly__INCOMING) && (
            <Button
              onClick={() => setIsVisiblePopupHandleDocument(true)}
              icon={<FormOutlined style={{ color: blue }} />}
              style={{ borderRadius: 6, color: blue, borderColor: blue }}>
              Xử lý văn bản
            </Button>
          )}

          <Dropdown overlay={menuHandleDocument} trigger={['click']}>
            <Button icon={<MoreOutlined />} style={{ borderRadius: 6 }} />
          </Dropdown>
        </HeadingButtonWrapper>
      </PageTitle>
      
      <DocumentContentWrapper style={{ display: 'flex', gap: 16 }}>
        <BlockLeft style={{ flex: 1, minWidth: 0, marginRight: 0, paddingRight: 0 }}>{renderAttachment}</BlockLeft>
        <BlockRight style={{ width: 420, flexShrink: 0 }}>
          <div style={{ backgroundColor: '#f5f7fa', padding: 24, borderRadius: 16, marginBottom: 16 }}>
            <Tabs defaultActiveKey="info" style={{ height: '100%' }}>
              <Tabs.TabPane tab="Thông tin chung" key="info">
                <div style={{ marginTop: 8 }}>
                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Số hiệu:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>{document_number}</div>
                  </div>
                  
                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Số đến:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>{incoming_number}</div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày ban hành:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {date_issued ? moment(date_issued).format(DATE_FORMAT_DEFAULT) : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có ngày ban hành.</span>}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày đến:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {incoming_date ? <><CalendarOutlined style={{ marginRight: 6, color: '#1890ff' }} />{moment(incoming_date).format(DATE_TIME_FORMAT_DEFAULT)}</> : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ ngày đến.</span>}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Người ký:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {signer ? signer : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người ký.</span>}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>CQ ban hành:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {WordBreak(renderAuthorityIssuedList(authority_issued_id, agency_issued))}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Tài liệu đính kèm:</div>
                    <div style={{ flex: 1, maxHeight: 150, overflowY: 'auto', paddingRight: 4 }}>
                      {attachments && attachments.length > 0 ? (
                        attachments.map(file => (
                          <FileItem
                            key={file.id}
                            file_id={file.id}
                            file_name={file.name}
                            file_type={utils.getExtensionFile(file.name)}
                          />
                        ))
                      ) : (
                        <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                      )}
                    </div>
                  </div>
                </div>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Liên kết" key="linked">
              <div style={{ marginTop: 8 }}>
                <div style={{ marginBottom: 20 }}>
                  <div style={{ color: '#555', fontWeight: 600, marginBottom: 10, fontSize: 14 }}>Liên kết nhiệm vụ</div>
                  <div>
                    {linkedTask && linkedTask.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <LinkedTask linkedTaskList={linkedTask} />
                      </div>
                    ) : (
                      <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                    )}
                  </div>
                </div>

                <div>
                  <div style={{ color: '#555', fontWeight: 600, marginBottom: 10, fontSize: 14 }}>Liên kết công việc</div>
                  <div>
                    {linkedWork && linkedWork.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <LinkedWork linkedWorkList={linkedWork} />
                      </div>
                    ) : (
                      <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                    )}
                  </div>
                </div>
              </div>
            </Tabs.TabPane>
          </Tabs>
          </div>
          
          <div style={{ backgroundColor: '#f5f7fa', padding: '16px 24px 24px 24px', borderRadius: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Ý kiến</div>
            <div style={{ position: 'relative' }}>
              <InternalDocumentComment documentId={documentId} setIsLoadingComment={bool => setIsLoadingComment(bool)} />
              <SpinnerInlineComponent sizeSpin={'small'} isLoading={isLoadingComment} />
            </div>
          </div>

          <div style={{ backgroundColor: '#f5f7fa', padding: '16px 24px 24px 24px', borderRadius: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Xử lý văn bản</div>
            {loading ? (
              <div style={{ height: 150, position: 'relative' }}>
                <SpinnerInlineComponent sizeSpin={'small'} tip="Đang tải dữ liệu..." isLoading={loading} backGround={'transparent'} />
              </div>
            ) : (
              <div style={{ paddingTop: 8 }}>
                <Row gutter={[16, 24]}>
                  <Col span={12}>
                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>Lãnh đạo xử lý</div>
                    <div style={{ fontSize: 14 }}>
                      {leaderUsers.length !== 0 ? (
                        <div>
                          <div style={{ color: '#333', marginBottom: 6, wordBreak: 'break-word' }}>{getAssigneeText(leaderUsers)}</div>
                          {cpctmLeaderUsers.length !== 0 ? (
                            <PopoverWatchTime departWithUsers={departWithUsers} userList={cpctmLeaderUsers} title={'Lãnh đạo xử lý'} isFullViewer={true} showViewLogLabel={true} compared_date={VIEWLOG_DATE.internal_document_until} typeId={documentId} created_at={created_at} />
                          ) : null}
                        </div>
                      ) : (
                        <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người xử lý.</span>
                      )}
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>Người xử lý</div>
                    <div style={{ fontSize: 14 }}>
                      {handlerUsers.length !== 0 ? (
                        <div>
                          <div style={{ color: '#333', marginBottom: 6, wordBreak: 'break-word' }}>{getAssigneeText(handlerUsers)}</div>
                          {cpctmHandlerUsers.length !== 0 ? (
                            <PopoverWatchTime departWithUsers={departWithUsers} userList={cpctmHandlerUsers} title={'Danh sách người xử lý'} isFullViewer={true} showViewLogLabel={true} compared_date={VIEWLOG_DATE.internal_document_until} typeId={documentId} created_at={created_at} />
                          ) : null}
                        </div>
                      ) : (
                        <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người xử lý.</span>
                      )}
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>Phối hợp/ Theo dõi:</div>
                    <div style={{ fontSize: 14 }}>
                      {followerUsers.length !== 0 ? (
                        <div>
                          <div style={{ color: '#333', marginBottom: 6, wordBreak: 'break-word' }}>{getAssigneeText(followerUsers)}</div>
                          {cpctmFollowerUsers.length !== 0 ? (
                            <PopoverWatchTime departWithUsers={departWithUsers} userList={cpctmFollowerUsers} title={'Danh sách người phối hợp/ theo dõi'} isFullViewer={true} showViewLogLabel={true} compared_date={VIEWLOG_DATE.internal_document_until} typeId={documentId} created_at={created_at} />
                          ) : null}
                        </div>
                      ) : (
                        <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                      )}
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>Ngày bắt đầu</div>
                    <div style={{ fontSize: 14, color: '#333' }}>
                      {start_date ? moment(start_date).format(DATE_FORMAT_DEFAULT) : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>}
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>Ngày kết thúc</div>
                    <div style={{ fontSize: 14, color: '#333' }}>
                      {end_date ? moment(end_date).format(DATE_FORMAT_DEFAULT) : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>}
                    </div>
                  </Col>
                </Row>
                
                <AccessControlAction aclActionType={ACL_ACTION_TYPE.phanphat__INCOMING}>
                  <div style={{ marginTop: 24 }}>
                    <Button 
                      type="primary" 
                      block 
                      size="large"
                      onClick={() => setIsVisiblePopupPhanPhatDocument(true)}
                      style={{ borderRadius: 6, fontWeight: 500 }}>
                      Phân phát
                    </Button>
                  </div>
                </AccessControlAction>
              </div>
            )}
          </div>
        </BlockRight>
      </DocumentContentWrapper>

      <PopupHandleDocument
        isVisiblePopupHandleDocument={isVisiblePopupHandleDocument}
        handleCancelHandleDocument={() =>
          setIsVisiblePopupHandleDocument(false)
        }
        handleCloseHandleDocument={() => setIsVisiblePopupHandleDocument(false)}
      />
      <PopupPhanPhatDocument
        typeDocument={DOCUMENT_TYPE.INCOMING}
        selectedInternalDocument={selectedInternalDocumentIncoming}
        commentLeaderList={commentLeaderList}
        isVisiblePopupPhanPhatDocument={isVisiblePopupPhanPhatDocument}
        handleClosePopupPhanPhatDocument={() =>
          setIsVisiblePopupPhanPhatDocument(false)
        }
      />
    </DashboardLayout>
  )
}

InternalDocumentIncomingIncomingDocDetailPage.propTypes = {}

export default inject(
  'accountStore',
  'commonStore',
  'internalDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'departmentStore',
  'staffStore',
  'fileStore',
  'notificationStore',
  'selectPeopleStore',
  'aclStore'
)(observer(InternalDocumentIncomingIncomingDocDetailPage))
